/**
 * Auto-generated version file - DO NOT EDIT
 * Generated by scripts/generate-version.mjs
 * Format: {package.json version}
 */
export const APP_VERSION_BUILD = '1.0.0';
